<template>
  <div class="home">
    <b-container class="bv-example-row">
      <b-row>
        <b-col class="p-0 menu">
          <Menu />
        </b-col cols="12" md="auto">
        <b-col>
          <Header />

          <b-container class="dashboard-content">

            This page displays transcription / question / response activity (most recent 100 items).<br />
            <b-link @click="downloadActivityLog()">Click here</b-link> to download <b><i>all</i></b> activity (may take some time).<br />

            <Spinner v-show="showSpinner" /><br />

            <b-table-simple hover small responsive borderless>
              <b-thead class="bg-dkblue text-white">
                <b-tr>
                  <b-th>Timestamp</b-th>
                  <b-th>Transcript</b-th>
                  <b-th>Matched Question</b-th>
                  <b-th>Response</b-th>
                  <b-th>Fg</b-th>
                  <b-th>Bg</b-th>
                  <b-th>Lighting</b-th>
                  <b-th style="width:3rem;" rowspan=2><b-link @click=""><b-icon @click="getActivityLog()" icon="arrow-clockwise" style="color: #fff"></b-icon></b-link></b-th>
                  <!--<b-th></b-th>-->
                </b-tr>
              </b-thead>
              <b-tbody v-for="result in results">
                <b-tr class="table-row">
                  <b-th>{{ result.timestamp }}</b-th>
                  <b-td>{{ result.transcript }}</b-td>
                  <b-td>{{ result.question }}</b-td>
                  <b-th>{{ result.response }}</b-th>
                  <b-td>{{ result.fg }}</b-td>
                  <b-td>{{ result.bg }}</b-td>
                  <b-td>{{ result.lighting }}</b-td>
                  <b-td></b-td>
                  <!--<b-td class="button-cell"><b-link @click="confirmDelete(result.email)"><b-icon @click="" icon="x-square"></b-icon></b-link></b-td>-->
                </b-tr>
              </b-tbody>
            </b-table-simple>

          </b-container>

        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Menu from '@/components/Menu.vue'
import Header from '@/components/Header.vue'
import Spinner from '@/components/Spinner.vue'
import dateFormat, { masks }  from 'dateformat';

const axios = require('axios')



export default {
  name: 'activity_log', 
  data(){
    return {
        showSpinner: false,
        newWhitelistUser: null,
        results: []
      }
  },
  mounted() {
    this.showSpinner = true,
    this.$store.state.page = "Activity Log"
    this.getActivityLog()

  },
  computed: {
    user () {
      return this.$store.state.user
      // { "logged": true, "loggedInAs": { "name": "Alok Wadhwani", "email": "alok@alokw.com" } }
    },
  },
  components: {
    Menu,
    Header,
    Spinner
  },
  methods: {

    downloadActivityLog() {
      this.showSpinner = true
      //this.results = []
      var url = this.$store.state.locals.apiUrl + '/downloadActivityLog'
      var config = {
        method: 'get',
        url: url,
        responseType: 'blob', // important
        headers: { 
          'api-key': this.$apikey, 
          'Content-Type': 'application/json'
        }
      };

      axios(config)
      .then((response) => {

        var now = new Date();
        var stamp = dateFormat(now, "yyyy-mm-dd_HH-MM-ss");
        var filename = 'mdcai_activity_log_' + stamp + '.xlsx'

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); //or any other extension
        document.body.appendChild(link);
        link.click();
        //this.results = response.data,
        //this.parseActivityLog(response.data),
        this.showSpinner = false

      })
      .catch((error) => {
        console.log(error);
        this.$store.state.error = error;
        this.$router.push('dashboard_error')
      });
    },

    getActivityLog() {
      this.showSpinner = true
      this.results = []
      var url = this.$store.state.locals.apiUrl + '/getActivityLog'
      var config = {
        method: 'get',
        url: url,
        headers: { 
          'api-key': this.$apikey, 
          'Content-Type': 'application/json'
        }
      };

      axios(config)
      .then((response) => {
        //this.results = response.data,
        this.parseActivityLog(response.data),
        this.showSpinner = false

      })
      .catch((error) => {
        console.log(error);
        this.$store.state.error = error;
        this.$router.push('dashboard_error')
      });
    },

    parseActivityLog(data) {
      //console.log(this.results)
      var parsedResults = []

      for (let key in data) {
        let item = data[key];

        var timestamp = new Date( item['timestamp'] ).toLocaleString()

        this.results.push({ 
          "timestamp"   : timestamp,
          "transcript" : item['transcript'],
          "question"    : item['question'],
          "response"    : item['response'],
          "fg"    : item['fg'],
          "bg"    : item['bg'],
          "lighting"    : item['lighting']
        });
      }
    },


  }
}
</script>
